// This remote content controller works with specially annotated HTML like:
//
// eslint-disable-next-line max-len
// <div data-controller="remote-content" data-remote-content-url="{url}" data-remote-content-refresh="{secs}">
// </div>

import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['output'];

  connect() {
    const self = this;
    self.contentUrl = this.data.get('url');
    self.refreshInterval = (parseInt(self.data.get('refresh'), 10) || 0) * 1000;
    self.loadContent();
    if (this.refreshInterval > 0) {
      window.setInterval(self.loadContent.bind(self), self.refreshInterval);
    }
  }

  loadContent() {
    const self = this;
    const el = self.element;
    $(el).addClass('remote-content--loading');
    $(el).load(self.contentUrl, () => {
      $('body').trigger('ajax-content-loaded', el);
      $(el).removeClass('remote-content--loading');
    });
  }
}
